package com.example.mystybag.login.views.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color

/**
 * Web is locked to Bulgarian, so the EN/BG language switcher is intentionally
 * disabled. The composable is kept (with its original signature) so existing
 * call sites compile, but it renders nothing.
 */
@Composable
fun WebInlineLanguageSwitcher(
    modifier: Modifier = Modifier,
    triggerTextColor: Color? = null,
    chevronTint: Color? = null,
) {
    // No-op: language is fixed to "bg" on web.
}
